module.exports = __webpack_public_path__ + "static/tinkering-57629e2815fcf8bb622398210ab2c539.jpg";